import { BasicObject } from './basic-object.model';

export class Operation {
  id!: number;
  constraint_id!: number;
  label!: string;

  constraint?: BasicObject;

  constructor(data: unknown = {}) {
    Object.assign(this, data);

    if (this.constraint) {
      this.constraint = new BasicObject(this.constraint);
    }
  }
}
